export const ScreenSizes = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const device = {
  xsOnly: `(max-width: ${ScreenSizes.sm - 1}px)`,
  smOnly: `(min-width: ${ScreenSizes.sm}px) and (max-width: ${
    ScreenSizes.md - 1
  }px)`,
  mdOnly: `(min-width: ${ScreenSizes.md}px) and (max-width: ${
    ScreenSizes.lg - 1
  }px)`,
  lgOnly: `(min-width: ${ScreenSizes.lg}px) and (max-width: ${
    ScreenSizes.xl - 1
  }px)`,
  smAndWider: `(min-width: ${ScreenSizes.sm}px)`,
  mdAndWider: `(min-width: ${ScreenSizes.md}px)`,
  lgAndWider: `(min-width: ${ScreenSizes.lg}px)`,
  xlAndWider: `(min-width: ${ScreenSizes.xl}px)`,
};
